import React from 'react';

import { showModal } from 'modal.react.js';
import queryString from 'query-string';
import { FieldValues, UseFormWatch } from 'react-hook-form';

import { getAccountId } from 'api/auth';
import { isTimeValid } from 'components/shared/BaseFormComponents/TimeInput/utils';
import { IDayRange } from 'components/shared/DatePicker/type';
import area from 'components/shared/GlobalModalArea/area';
import store from 'configureStore';
import { PAGE_STATUS_APPROVED } from 'constants/index';
import { IDatesRange, TTripEvent } from 'detailsv2/structure';
import { isAgentSelector } from 'store/user/selectors';
import { axiosGetAutoCancelDecorator } from 'utils/axiosGetAutoCancelDecorator';
import { createOptionFromPage } from 'utils/createOptionFromPage';
import { getHoursAndMinutes12, getHoursAndMinutes24 } from 'utils/date';
import { decamelizeKeys } from 'utils/humps';

import Modal from '../../../../../../../../shared/Modal';
import Preview from '../../../../../../shared/Preview';

import EditModal from './index';

export function editTripEvent(tripEvent: TTripEvent) {
  return showModal<TTripEvent[] | false>(area, <EditModal tripEvent={tripEvent} />);
}

export const useDaysOrDate = (watch: UseFormWatch<FieldValues>) => {
  const datesRangeStart = watch && watch('datesRange.start');
  const daysRangeStart = watch && watch('daysRange.start');

  const onChangeStartDate = (val: IDatesRange, onChange: (...event: any[]) => void) => {
    onChange(val.start);
  };

  const onChangeEndDate = (val: IDatesRange, onChange: (...event: any[]) => void) => {
    onChange(val.start);
  };

  const onChangeStartDay = (val: IDayRange, onChange: (...event: any[]) => void) => {
    onChange(val.start);
  };

  const onChangeEndDay = (val: IDayRange, onChange: (...event: any[]) => void) => {
    onChange(val.start);
  };

  return { datesRangeStart, daysRangeStart, onChangeStartDate, onChangeEndDate, onChangeStartDay, onChangeEndDay };
};

const decoratedAxiosGet = axiosGetAutoCancelDecorator();
export const getOptionsLoader =
  (types: string[] = [], createOption: any = createOptionFromPage) =>
  async (q?: string, additionalFilterQueryParams?: any) => {
    const accountId = getAccountId();
    const isAgent = isAgentSelector(store.getState());

    const query = queryString.stringify(
      decamelizeKeys({
        q,
        ...additionalFilterQueryParams,
        accountId,
        types,
        limit: 100,
        statuses: [PAGE_STATUS_APPROVED],
        orderBy: 'handle',
        countless: 1,
      }),
      { skipNull: true, skipEmptyString: true, arrayFormat: 'bracket' },
    );

    const response = await decoratedAxiosGet(`/acc/${accountId}/pages/dropdown?${query}`);

    return response.data.data.map((page: any) => createOption(page, { isAgent }));
  };

export const getMinutesAndHoursFormatV2 = (date: Date, utc: string) => {
  const preparedUtc = parseFloat(Number(utc).toFixed(2));
  const utcFormat = Math.sign(preparedUtc) === -1 ? preparedUtc : `+${preparedUtc}`;
  const utcText = utc ? ` (UTC${utcFormat})` : '';

  return `${getHoursAndMinutes12(date)} (${getHoursAndMinutes24(date)}) ${utcText}`;
};

export const timeFormatValidation = (value?: string | undefined, optional?: boolean) => {
  if (!value && optional) return true;
  if (!value) return false;

  const [time] = value.split(' ');
  return isTimeValid(time);
};
export const optionalTimeFormatValidation = (value?: string | undefined) => timeFormatValidation(value, true);

export const timeLengthValidation = (value: string | undefined, optional?: boolean) => {
  if (!value && optional) return true;
  if (!value) return false;

  return value.length === 0 || value.length === 8;
};
export const optionalTimeLengthValidation = (value?: string | undefined) => timeLengthValidation(value, true);

export const openPagePreview = (pageId: number) => {
  showModal(area, (res) => (
    //@ts-ignore
    <Modal noPadding size="lg" isOpen toClose={res}>
      <Preview pageId={pageId} />
    </Modal>
  ));
};
